import React from 'react'

import Markdown from 'components/Markdown/Markdown'

import styles from './MarkdownContent.module.css'

type MarkdownContentProps = {
  source: string
}

const MarkdownContent: React.FC<MarkdownContentProps> = ({ source }) => {
  return (
    <div className={styles.markdownContent}>
      <Markdown>{source}</Markdown>
    </div>
  )
}
export default MarkdownContent
